import { t } from '../i18n';
import { Btn } from './common';
import { closeIntro, introOpen } from '../app/hints';
import { KEY_LABELS } from '../game/input';
import { isTouchUi } from '../app/device';

/** Four things a new player must know before the first realm; shown once, available again from Settings. */
export function IntroModal() {
  if (!introOpen.value) return null;
  const tiles: { glyph: string; title: string; text: string }[] = [
    { glyph: '⌨', title: t('intro.move.title'), text: t('intro.move.text') },
    { glyph: '✦', title: t('intro.skills.title'), text: isTouchUi() ? t('intro.skillsTouch') : t('intro.skills.text', { keys: KEY_LABELS.skills.join(' '), build: KEY_LABELS.build }) },
    { glyph: '☣', title: t('intro.goal.title'), text: t('intro.goal.text') },
    { glyph: '⚑', title: t('intro.leave.title'), text: isTouchUi() ? t('intro.leaveTouch') : t('intro.leave.text', { key: KEY_LABELS.leave }) },
  ];
  // a phone gets its own first tile: the sticks replace every key the others mention
  if (isTouchUi()) {
    tiles.shift();
    tiles.unshift({ glyph: '⊙', title: t('intro.touch.title'), text: t('intro.touch.text') });
  }
  return (
    <div class="modal intro">
      <div class="card wide panel col pop">
        <h2>{t('intro.title')}</h2>
        <div class="muted">{t('intro.sub')}</div>
        <div class="intro-grid">
          {tiles.map((tile) => (
            <div class="intro-tile">
              <div class="glyph">{tile.glyph}</div>
              <b>{tile.title}</b>
              <div class="small muted">{tile.text}</div>
            </div>
          ))}
        </div>
        <div class="row" style={{ justifyContent: 'flex-end' }}>
          <Btn onClick={() => closeIntro(false)}>{t('btn.later')}</Btn>
          <Btn primary onClick={() => closeIntro(true)}>
            {t('intro.go')}
          </Btn>
        </div>
      </div>
    </div>
  );
}
